<template>
  <div
    v-loading.fullscreen.lock="loadingSave"
    element-loading-text="Aguarde enquanto o email é processado..."
  >
    <ed-modal
      :title="
        'ENVIAR ASO POR EMAIL' +
        (parent.consulta ? ' - CONSULTA ' + parent.consulta.id_con : '')
      "
      :modal="parent.showDownloadASO"
      :loadingSave="loadingSave"
      :loading="parent.loadingDownloadASO"
      :onSave="salvar"
      width="95%"
    >
      <div slot="modal-content">
        <el-tabs
          type="border-card"
          v-model="tagConfig"
          @tab-click="handleClick"
        >
          <el-tab-pane label="Config" name="tab-cadastro">
            <span slot="label">
              <i class="fa fa-paper-plane"></i> Enviar novo Email
            </span>

            <el-alert
              title="Atenção"
              type="warning"
              description="Informe abaixo o destinatário. Você pode adicionar vários emails separado por ; (ponto e vírgula)."
              show-icon
            ></el-alert>

            <el-form
              label-position="top"
              label-width="100px"
              :model="formData"
              ref="ruleForm"
            >
              <div class="col-md-12">
                <el-form-item
                  label="Empresa"
                  prop="id_emp"
                  :rules="[
                    {
                      required: formData.tipo == 2,
                      message: 'Campo Obrigatorio',
                    },
                  ]"
                >
                  <el-select
                    v-model="empresa"
                    filterable
                    remote
                    clearable
                    placeholder="Digite o nome da empresa"
                    :remote-method="getEmpresa"
                    :loading="loadingEmpresa"
                    :disabled="parent.consulta ? true : false"
                    @change="getConsulta"
                    value-key="id"
                  >
                    <el-option
                      v-for="item in lstEmpresa"
                      :key="item.id"
                      :value="item"
                      :label="item.nome"
                    >
                      <div style="float: left">
                        <b>{{ item.nome }}</b>
                      </div>
                      <div
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item.cnpj }}
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="col-md-12">
                <el-form-item
                  label="Destinatário"
                  prop="destinatario"
                  :rules="[{ required: true, message: 'Campo Obrigatorio' }]"
                >
                  <el-input
                    placeholder="Digite o destinatário (separado por `;` ponto e vírgula)"
                    v-model="formData.destinatario"
                    :disabled="!formData.id_emp ? true : false"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="col-md-12">
                <el-form-item
                  label="Observações"
                  prop="obs"
                  :rules="[{ required: false, message: 'Campo Obrigatorio' }]"
                >
                  <el-input
                    type="textarea"
                    placeholder="O conteúdo deste campo será anexado junto com o email enviado para o destinatário..."
                    v-model="formData.obs"
                    :disabled="!formData.id_emp ? true : false"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="col-md-12">
                <el-form-item
                  label="Consulta"
                  prop="id_con"
                  :rules="[
                    {
                      required: formData.tipo == 2,
                      message: 'Campo Obrigatorio',
                    },
                  ]"
                >
                  <span slot="label">
                    Consulta
                    <el-checkbox
                      v-model="formData.todos"
                      :disabled="
                        !formData.id_emp || (parent.consulta ? true : false)
                      "
                      >Selecionar Todas as Consultas</el-checkbox
                    >
                  </span>

                  <el-select
                    v-model="formData.consultas"
                    clearable
                    multiple
                    collapse-tags
                    placeholder="Selecione a consulta"
                    :loading="loadingConsulta"
                    :disabled="
                      formData.todos == 1 ||
                      !formData.id_emp ||
                      (parent.consulta ? true : false)
                    "
                    value-key="id_con"
                  >
                    <el-option
                      v-for="item in lstConsulta"
                      :key="item.id_con"
                      :value="item"
                      :label="
                        'CÓD ' +
                        item.id_con +
                        ((item.dt_cad
                          ? ' | ' + toDate(item.dt_cad, true)
                          : '') +
                          (item.tipo_aso
                            ? ' | ' + item.tipo_aso.descricao.toUpperCase()
                            : '') +
                          (item.tipo_status
                            ? ' | ' + item.tipo_status.descricao.toUpperCase()
                            : ''))
                      "
                    >
                      <div style="float: left">
                        CÓD {{ item.id_con }} |
                        {{ item.dt_cad ? toDate(item.dt_cad, true) : "" }} |
                        {{
                          item.tipo_aso
                            ? item.tipo_aso.descricao.toUpperCase()
                            : ""
                        }}
                        {{
                          item.tipo_status
                            ? " | " + item.tipo_status.descricao.toUpperCase()
                            : ""
                        }}
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="col-md-12">
                <el-form-item
                  label="Anexar os Seguintes Documentos"
                  prop="id_con"
                  :rules="[
                    {
                      required: formData.tipo == 2,
                      message: 'Campo Obrigatorio',
                    },
                  ]"
                >
                  <el-checkbox-group v-model="formData.tipo_documento" :min="1">
                    <el-checkbox
                      style="width: 100% !important"
                      v-for="tipo in lstTipoDocumento"
                      :label="tipo.id"
                      :key="tipo.id"
                      :disabled="!formData.id_emp"
                      >{{ tipo.descricao }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </div>

              <div class="col-md-12" v-if="formData.consultas.length > 0">
                <table class="table table-hover has-gutter" width="100%">
                  <thead>
                    <tr>
                      <th width="400">CONSULTA</th>
                      <th>DOCUMENTOS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(consulta, i) in formData.consultas" :key="i">
                      <td valign="top">
                        <div class="col-md-12" style="text-align: left">
                          <b>CÓD:</b>
                          {{ consulta.id_con }}
                          <br />
                          <span style="font-size: 7pt">{{
                            consulta.funcionario.nome
                          }}</span>
                          <br />
                          <span style="font-size: 7pt">{{
                            consulta.empresa.nome
                          }}</span>
                        </div>
                      </td>
                      <td valign="top">
                        <div class="row">
                          <div class="col-md-6" style="text-align: left">
                            <b>
                              <i
                                class="fa fa-hand-o-right"
                                aria-hidden="true"
                              ></i>
                              Atestado de Saúde Ocupacional
                              <br />
                            </b>
                            <p v-if="consulta.arquivo_aso">
                              <a
                                href="#"
                                @click="downloadFile(consulta.arquivo_aso)"
                              >
                                <Download :arquivo="consulta.arquivo_aso" />
                              </a>
                              <span style="font-size: 7pt">
                                <b>
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="Aqui você pode escolher quais páginas do documento serão enviadas por email."
                                    placement="top"
                                  >
                                    <a href="#">
                                      <i
                                        class="fa fa-question-circle"
                                        aria-hidden="true"
                                      />
                                      Páginas
                                    </a>
                                  </el-tooltip>
                                </b>
                                <el-select
                                  v-model="consulta.arquivo_aso.select_pages"
                                  collapse-tags
                                  multiple
                                  placeholder="Selecione as páginas"
                                  style="width: 210px !important"
                                >
                                  <el-option
                                    v-for="item in consulta.arquivo_aso.pages"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                  ></el-option>
                                </el-select>
                              </span>
                            </p>
                            <p v-else>Nenhum arquivo</p>
                          </div>

                          <div class="col-md-6" style="text-align: left">
                            <b>
                              <i
                                class="fa fa-hand-o-right"
                                aria-hidden="true"
                              ></i>
                              Exames Complementares
                              <br />
                            </b>
                            <p v-if="consulta.arquivo_prontuario">
                              <a
                                href="#"
                                @click="
                                  downloadFile(consulta.arquivo_prontuario)
                                "
                              >
                                <i class="fa fa-download" aria-hidden="true" />
                                <Download
                                  :arquivo="consulta.arquivo_prontuario"
                                />
                              </a>
                              <b>
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  content="Aqui você pode escolher quais páginas do documento serão enviadas por email."
                                  placement="top"
                                >
                                  <a href="#">
                                    <i
                                      class="fa fa-question-circle"
                                      aria-hidden="true"
                                    />
                                    Páginas
                                  </a>
                                </el-tooltip>
                              </b>
                              <el-select
                                v-model="
                                  consulta.arquivo_prontuario.select_pages
                                "
                                collapse-tags
                                multiple
                                placeholder="Selecione as páginas"
                                style="width: 210px !important"
                              >
                                <el-option
                                  v-for="item in consulta.arquivo_prontuario
                                    .pages"
                                  :key="item"
                                  :label="item"
                                  :value="item"
                                ></el-option>
                              </el-select>
                            </p>
                            <p v-else>Nenhum arquivo</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-historico">
            <span slot="label">
              <i
                :class="
                  'fa fa-history' + (novaLiberacao ? ' faa-flash animated' : '')
                "
              ></i>
              Histórico de Envio de Emails
            </span>
            <DownloadAsoEmail ref="downloadAsoEmailComponent" :parent="parent" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import Fct from "common/fct";
import Download from "common/download";
import EdModal from "common/modal";
import DownloadAsoEmail from "./download-aso-email";

export default {
  name: "empresa",
  components: {
    TableView,
    Download,
    EdModal,
    DownloadAsoEmail,
  },
  mixins: [Rest, Fct, Download],
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.showDownloadASO": async function () {
      this.formData.obs = null;
      this.tagConfig = "tab-cadastro";

      await this.delay(500);

      if (this.parent.consulta) {
        this.formData = {
          destinatario: this.parent.consulta.empresa.email,
          consultas: [this.parent.consulta],
          id_emp: this.parent.consulta.empresa.id,
          id_fun: null,
          obs: null,
          todos: false,
          tipo_documento: [82],
        };
        this.lstConsulta = [this.parent.consulta];
        this.lstEmpresa = [this.parent.consulta.empresa];
        this.empresa = this.parent.consulta.empresa;
      } else {
        this.inicialize();
      }
    },
    "parent.consulta.id"() {
      if (this.parent.consulta) {
        this.formData = {
          destinatario: this.parent.consulta.empresa.email,
          consultas: [this.parent.consulta],
          id_emp: this.parent.consulta.empresa.id,
          id_fun: null,
          obs: null,
          todos: false,
          tipo_documento: [82],
        };
        this.lstConsulta = [this.parent.consulta];
        this.lstEmpresa = [this.parent.consulta.empresa];
        this.empresa = this.parent.consulta.empresa;
      } else {
        this.inicialize();
      }
    },
  },
  data() {
    return {
      formData: {
        destinatario: null,
        todos: false,
        id_emp: null,
        id_fun: null,
        obs: null,
        consultas: [],
        tipo_documento: [82],
      },
      empresa: null,
      pagination: {},
      error: {},
      tableHead: [
        {
          key: "data",
          sortable: true,
          width: "120px",
          label: "Data",
        },
        {
          key: "usuario",
          sortable: true,
          label: "Usuário",
        },
        {
          key: "lote",
          sortable: true,
          width: "55px",
          label: "Lote",
        },
        {
          key: "consulta",
          sortable: true,
          show_tipo_aso: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "destinatario",
          sortable: true,
          show_html: true,
          label: "Destinatário",
        },
        {
          key: "obs",
          sortable: true,
          limit: 20,
          label: "Obs",
        },
        {
          key: "documento",
          sortable: true,
          show_html: true,
          label: "Documento",
        },
        {
          key: "status",
          sortable: true,
          show_status: true,
          label: "Status",
        },
      ],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstConsulta: [],
      lstTipoDocumento: [],
      loadingFuncionario: false,
      loadingConsulta: false,
      loadingEmpresa: false,
      loadingEditAll: false,
      loadingTable: false,
      loadingSave: false,
      novaLiberacao: false,
      tagConfig: "tab-cadastro",
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted: function () {
    this.getEmpresa();
    this.getTipo();
    this.inicialize();
  },

  methods: {
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    inicialize: function () {
      this.formData = {
        destinatario: null,
        id_emp: null,
        id_fun: null,
        consultas: [],
        todos: false,
        obs: null,
        tipo_documento: [82],
      };
      this.lstConsulta = [];
      this.empresa = null;
    },

    handleClick(tab, event) {
      this.novaLiberacao = false;
    },

    getEmpresa: function (_search) {
      this.loadingEmpresa = true;

      var filter = {
        id_tipo_email: [197],
        show_emp_email: 1,
      };

      this.get("/empresa", {
        search: _search,
        filter: filter,
      }).then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.lstEmpresa = result.data.data;
        } else {
          this.lstEmpresa = [];
        }

        this.loadingEmpresa = false;
      });
    },

    getFuncionario: function (_search) {
      if (!this.formData.id_emp) return;

      this.loadingFuncionario = true;
      this.lstFuncionario = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
      }).then((result) => {
        result = result[0];

        this.loadingFuncionario = false;

        if (result.status == 200) {
          this.lstFuncionario = result.data.data;
        }
      });
    },

    getConsulta: async function (_search) {
      if (!this.empresa) return;

      this.formData.id_emp = this.empresa.id;
      this.formData.destinatario = this.empresa.email;

      if (!this.formData.id_emp) return;

      this.loadingConsulta = true;
      this.lstConsulta = [];

      var hoje = this.toDate(null, true),
        ontem = this.toDate(this.addDate(-365 * 2, null, "D"), true),
        amanha = this.toDate(this.addDate(1, null, "D"), true);

      var filter = {
        id_empresa: this.formData.id_emp,
        with_arquivo: 1,
        created_at: [ontem, amanha],
      };

      await this.delay(500);

      this.get("/empresa/consulta", {
        filter: filter,
        pagination: 1000,
      }).then((result) => {
        result = result[0];

        this.loadingConsulta = false;

        if (result.status == 200) {
          this.lstConsulta = result.data.data;
        }
      });
    },

    getTipo: function () {
      this.post("tipo/parent", {
        codigo: [81],
        exclude: [84, 88],
      }).then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.lstTipoDocumento = result.data["81"];
        }
      });
    },

    salvar: async function () {
      this.loadingSave = true;

      this.post(
        "empresa/consulta/email/" +
          (this.parent.consulta ? this.parent.consulta.id_con : 0) +
          "/cadastrar",
        this.formData
      ).then(async (result) => {
        result = result[0];

        this.loadingSave = false;

        if (result.status == 200) {
          this.$message({
            message:
              "Email cadastrado com sucesso! O envio pode levar alguns minutos para ser realizado. Por favor aguarde!",
            type: "success",
          });

          this.error = {};
          this.novaLiberacao = true;
          this.tagConfig = "tab-historico";

          await this.delay(500);

          this.$refs.downloadAsoEmailComponent.getConsultaEmail();
        }
      });
    },



  },
};
</script>



// WEBPACK FOOTER //
// download-aso.vue?14e880ef